









import { defineComponent, ref } from "@vue/composition-api";
import { InputIuguPIXDetails, PIXResponse } from "@scrile/api-provider/dist/api/IuguPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { RecurringBillingScheduleSubjectTypeEnum } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import providers from "@/lib/api";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import PixEditView from "./PixEditView.vue";

export default defineComponent({
  name: "PixType",
  components: { PixEditView, ModalView, PageTitle },
  props: {
    pricePackageId: { type: String, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    price: { type: String },
    purchaseSubject: { type: Object as () => Subject<PurchaseSubjectTypeEnum> },
    subscriptionSubject: { type: Object as () => Subject<RecurringBillingScheduleSubjectTypeEnum> },
  },
  setup(props, { emit }) {
    const show = ref(false);
    const processing = ref(false);
    const qrUrl = ref("");
    const onSubmit = async (data: InputIuguPIXDetails) => {
      try {
        processing.value = true;
        let response: PIXResponse;
        if (!props.subscriptionSubject) {
          response = await providers.IuguPurchaseProvider.iuguGeneratePIXInvoice({
            data: {
              pricePackageId: props.pricePackageId,
              paymentSystemId: props.paymentSystem.id,
              currency: getMainCurrencyCode(),
              billingDetails: data,
              subject: props.purchaseSubject,
            },
          });
        } else {
          response = await providers.IuguPurchaseProvider.iuguGeneratePIXRecurringInvoice({
            data: {
              paymentSystemId: props.paymentSystem.id,
              currency: getMainCurrencyCode(),
              billingDetails: data,
              subject: props.subscriptionSubject,
            },
          });
        }
        qrUrl.value = response.qrCodeUrl;
      } finally {
        processing.value = false;
      }
    };

    const onClose = () => {
      if (qrUrl.value) {
        emit("submit", { type: "pix", purchaseSubject: props.purchaseSubject });
      } else {
        emit("close");
      }
    };

    return {
      show,
      qrUrl,
      processing,
      onClose,
      onSubmit,
    };
  },
});
